// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* на цифры */
.word-search-number {
  width: 3vw;
  height: 3vw;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 1.5vw;
  font-weight: bold;
  border-left: 0.1vw #1a6a7c solid;
  border-top: 0.1vw #1a6a7c solid;
}
.word-search-number--has-number{
  background-color: #1a6a7c3d;
}
/* Код */
.navigatorCode-board-game-code--Type2 {
  width: -moz-fit-content;
  width: fit-content;
  place-self: center;
  display: grid;
  --cell-size: 5vw;
  height: var(--cell-size);
  border: 0.1vw #1a6a7c solid;
  background-color: white;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}
.navigatorCode-code-small--Type2{
  --cell-size:4vw;
}
.navigatorCode-board-game-code-cell--Type2 {
  width: 4vw;
  height: 4vw;
  border-right: 0.1vw #1a6a7c solid;
  place-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3vw ;
  
  -webkit-user-select: none;
  
          user-select: none;
}
.navigatorCode-code-cell-small--Type2{
  width: 3vw;
  height: 3vw;
  font-size: 2vw;
}

.navigatorCode-board-game-code-cell--Type2:last-child {
  border-right: none;
}
.navigatorCode-arrow--Type2 {
  transform: translateY(-0.2vw);
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/Navigator%D0%A1odeBoardType2.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,UAAU;EACV,WAAW;;EAEX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA,QAAQ;AACR;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB;;mCAEiC;AACnC;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,yBAAiB;;UAAjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":["/* на цифры */\n.word-search-number {\n  width: 3vw;\n  height: 3vw;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-size: 1.5vw;\n  font-weight: bold;\n  border-left: 0.1vw #1a6a7c solid;\n  border-top: 0.1vw #1a6a7c solid;\n}\n.word-search-number--has-number{\n  background-color: #1a6a7c3d;\n}\n/* Код */\n.navigatorCode-board-game-code--Type2 {\n  width: fit-content;\n  place-self: center;\n  display: grid;\n  --cell-size: 5vw;\n  height: var(--cell-size);\n  border: 0.1vw #1a6a7c solid;\n  background-color: white;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n.navigatorCode-code-small--Type2{\n  --cell-size:4vw;\n}\n.navigatorCode-board-game-code-cell--Type2 {\n  width: 4vw;\n  height: 4vw;\n  border-right: 0.1vw #1a6a7c solid;\n  place-self: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 3vw ;\n  \n  user-select: none;\n}\n.navigatorCode-code-cell-small--Type2{\n  width: 3vw;\n  height: 3vw;\n  font-size: 2vw;\n}\n\n.navigatorCode-board-game-code-cell--Type2:last-child {\n  border-right: none;\n}\n.navigatorCode-arrow--Type2 {\n  transform: translateY(-0.2vw);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
